import {
  Badge as ChakraBadge,
  BadgeProps,
  ComponentWithAs,
} from '@chakra-ui/react';
import theme from '~/common/customTheme/theme';

export const Badge: ComponentWithAs<'span', BadgeProps> = ({
  children,
  ...props
}) => {
  return (
    <ChakraBadge
      backgroundColor={theme.colors.primary}
      color="white"
      alignSelf="flex-start"
      {...props}
    >
      {children}
    </ChakraBadge>
  );
};
